// hooks
import { useStore } from '@/store';
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useGeoRecordCommentService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    const getGeoRecordCommentsByGeoRecordId = async (geoRecordId:number = 0): Promise<any> => {
        const res = await axios.get(`${apiUrl}/geo-record-comment/${geoRecordId}`);
        if(res.status == 200){
            return res.data;
        }
        else{
            return false
        }
    };

    const createGeoRecordComment = async (geoRecordComment: any): Promise<any> => {
        const res = await axios.post(`${apiUrl}/geo-record-comment`, geoRecordComment);
        if(res.status == 200){
            return res.data;    //Successfully created and have returned the updated comments
        }
        else if(res.status == 201){
            return true     //Successfully created but haven't returned the updated comments
        }
        else{
            return false    //Error
        }
    };

    const deleteGeoRecordComment = async (id: number, geoRecordId:number): Promise<any> => {
        const res = await axios.deleteId(`${apiUrl}/geo-record-comment/${id}/${geoRecordId}`);
        if(res.status == 200){
            return res.data;    //Successfully deleted and have returned the updated comments
        }
        else if(res.status == 201){
            return true     //Successfully deleted but haven't returned the updated comments
        }
        else{
            return false    //Error
        }
    };

    return {
        getGeoRecordCommentsByGeoRecordId,
        createGeoRecordComment,
        deleteGeoRecordComment,
    };
};
